import React from "react";
import ReactPaginate from 'react-paginate';

export default function Pagination({ pageCount, onPageChange, currentPage }) {

    return (
        <ReactPaginate
            breakLabel="..."
            nextLabel=">"
            onPageChange={onPageChange}
            pageRangeDisplayed={3}
            pageCount={pageCount}
            previousLabel="<"
            renderOnZeroPageCount={null}
            marginPagesDisplayed={2}
            forcePage={currentPage}
            containerClassName="pagination-container"
            pageClassName="pagination-item"
            activeClassName="active"
            previousClassName="pagination-previous"
            nextClassName="pagination-next"
        />

    )
}